import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { StageSetup, StageSetupParams } from '../../interfaces/career-setup/stage-setup.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { PageResponse } from '../../interfaces/page-response.interface';

export abstract class StageSetupService extends BaseService<StageSetup> {
  abstract getStages(params: StageSetupParams): Observable<StageSetup[]>;

  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<StageSetup>>;
  abstract override find(id: string): Observable<StageSetup>;
  abstract override create(data: Partial<StageSetup>): Observable<StageSetup>;
  abstract override update(id: string, data: Partial<StageSetup>): Observable<StageSetup>;
  abstract updateStatus(id: string, isActive: boolean): Observable<StageSetup>;
  abstract override delete(id: string): Observable<void>;
}
